var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-header", {
        staticClass: "pb-6 pb-8 pt-5 pt-md-8",
        attrs: { type: "gradient-primary" }
      }),
      _c("div", { staticClass: "container-fluid mt--7" }, [
        _c("div", { staticClass: "row mt-5" }, [
          _c("div", { staticClass: "col-xl-12" }, [
            _c("div", { staticClass: "row justify-content-center" }, [
              !this.showLinkInfo
                ? _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "card bg-secondary shadow border-0 ",
                        staticStyle: { "margin-bottom": "250px" }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "m-3",
                            staticStyle: { color: "#9C1C00" },
                            attrs: { slot: "title" },
                            slot: "title"
                          },
                          [_vm._v("ZumaLink")]
                        ),
                        _c(
                          "b-container",
                          [
                            _c("enterprise-branch-selector", {
                              attrs: {
                                errorEnterprise: _vm.validateField(
                                  "idEnterprise"
                                ),
                                errorBranch: _vm.validateField("idBranch")
                              },
                              on: {
                                "branch-selected": _vm.branchSelected,
                                "enterprise-selected": _vm.enterpriseSelected
                              }
                            }),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-control-label" },
                                      [
                                        _vm._v(
                                          "\n                        Selecciona tipo de pago.\n                      "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mt-1",
                                        staticStyle: { background: "white" }
                                      },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            label: "label",
                                            value: _vm.promotionSelected,
                                            reduce: function(label) {
                                              return label.cardPromotionCode
                                            },
                                            placeholder:
                                              "Seleccione una opción",
                                            options: _vm.promotions
                                          },
                                          model: {
                                            value: _vm.data.promotion,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                "promotion",
                                                $$v
                                              )
                                            },
                                            expression: "data.promotion"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._t("helpBlock", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-danger invalid-feedback",
                                          staticStyle: { display: "block" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.validateField("promotion")
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  2
                                ),
                                _c(
                                  "b-col",
                                  [
                                    _c("base-input", {
                                      attrs: {
                                        "input-classes":
                                          "form-control-alternative",
                                        label: "Vigencia del código(Días)*:",
                                        error: _vm.validateField("expire"),
                                        validation: "number"
                                      },
                                      model: {
                                        value: _vm.data.expire,
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, "expire", $$v)
                                        },
                                        expression: "data.expire"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("base-input", {
                                      attrs: {
                                        "input-classes":
                                          "form-control-alternative",
                                        label: "Ingresa el monto*:",
                                        error: _vm.validateField("amount"),
                                        validation: "number"
                                      },
                                      model: {
                                        value: _vm.data.amount,
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, "amount", $$v)
                                        },
                                        expression: "data.amount"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("base-input", {
                                      attrs: {
                                        "input-classes":
                                          "form-control-alternative",
                                        label: "Referencia:",
                                        error: _vm.validateField("reference"),
                                        maxlength: 40
                                      },
                                      on: { input: _vm.validate },
                                      model: {
                                        value: _vm.data.reference,
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, "reference", $$v)
                                        },
                                        expression: "data.reference"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "base-button",
                          {
                            staticClass: "my-4 ml-3 mr-3",
                            attrs: { type: "primary" },
                            on: { click: _vm.validateAmounts }
                          },
                          [_vm._v("Generar liga de pago")]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              this.showLinkInfo
                ? _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "card bg-secondary shadow border-0 ",
                        staticStyle: { "margin-bottom": "250px" }
                      },
                      [
                        _c("span", { staticClass: "m-3" }, [
                          _vm._v("La liga de pago fue generada exitosamente ")
                        ]),
                        _c(
                          "b-container",
                          [
                            _c(
                              "b-row",
                              { attrs: { "align-v": "center" } },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "7" } },
                                  [
                                    _c("base-input", {
                                      attrs: {
                                        "input-classes":
                                          "form-control-alternative",
                                        label: "ZumaLink:",
                                        disabled: "true"
                                      },
                                      model: {
                                        value: _vm.dataUrl.link,
                                        callback: function($$v) {
                                          _vm.$set(_vm.dataUrl, "link", $$v)
                                        },
                                        expression: "dataUrl.link"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "5" } },
                                  [
                                    _c(
                                      "base-button",
                                      {
                                        directives: [
                                          {
                                            name: "clipboard",
                                            rawName: "v-clipboard:copy",
                                            value: this.dataUrl.link,
                                            expression: "this.dataUrl.link",
                                            arg: "copy"
                                          },
                                          {
                                            name: "clipboard",
                                            rawName: "v-clipboard:success",
                                            value: _vm.copy,
                                            expression: "copy",
                                            arg: "success"
                                          }
                                        ],
                                        staticClass: "my-4 ml-3 mr-3",
                                        staticStyle: { width: "70%" },
                                        attrs: { type: "primary" }
                                      },
                                      [_vm._v(" Copiar")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "7" } },
                                  [
                                    _c("base-input", {
                                      attrs: {
                                        "input-classes":
                                          "form-control-alternative",
                                        label: "Email:",
                                        maxlength: 64,
                                        error: _vm.validateField("mail")
                                      },
                                      model: {
                                        value: _vm.dataUrl.mail,
                                        callback: function($$v) {
                                          _vm.$set(_vm.dataUrl, "mail", $$v)
                                        },
                                        expression: "dataUrl.mail"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "5" } },
                                  [
                                    _c(
                                      "base-button",
                                      {
                                        staticClass: "my-4 ml-3 mr-3",
                                        staticStyle: { width: "70%" },
                                        attrs: { type: "primary" },
                                        on: { click: _vm.sendEmail }
                                      },
                                      [_vm._v("Compartir por correo de Zuma")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "base-button",
                          {
                            staticClass: "my-4 ml-3 mr-3",
                            attrs: { type: "primary" },
                            on: { click: _vm.resetData }
                          },
                          [_vm._v("Generar una nueva liga")]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }